import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3ZM16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM12.7071 11.2929L12.6129 11.2097C12.2206 10.9047 11.6534 10.9324 11.2929 11.2929C10.9024 11.6834 10.9024 12.3166 11.2929 12.7071L14.585 16L11.2929 19.2929L11.2097 19.3871C10.9047 19.7794 10.9324 20.3466 11.2929 20.7071C11.6834 21.0976 12.3166 21.0976 12.7071 20.7071L16 17.415L19.2929 20.7071L19.3871 20.7903C19.7794 21.0953 20.3466 21.0676 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L17.415 16L20.7071 12.7071L20.7903 12.6129C21.0953 12.2206 21.0676 11.6534 20.7071 11.2929C20.3166 10.9024 19.6834 10.9024 19.2929 11.2929L16 14.585L12.7071 11.2929Z"
	})
});
export default SvgXCircle;
